/**
 * EHR Feature Flags
 *
 * Mirrors featureFlags from backend external-systems.json.
 * Centralized here so all EHR-specific behavior is defined in one place.
 *
 * To add a new EHR or flag:
 * 1. Add it to backend/src/config/external-systems.json under featureFlags
 * 2. Add the matching entry here
 */

const EHR_FEATURE_FLAGS: Record<string, Record<string, boolean>> = {
  caretracker: {
    preLocalizedScheduledTime: true,
  },
};

/** Check if a specific feature flag is enabled for an EHR system */
export function hasEhrFeatureFlag(systemId: string, flag: string): boolean {
  return EHR_FEATURE_FLAGS[systemId]?.[flag] === true;
}

/** Get all system IDs that have a given feature flag enabled */
export function getSystemsWithFlag(flag: string): Set<string> {
  return new Set(
    Object.entries(EHR_FEATURE_FLAGS)
      .filter(([, flags]) => flags[flag] === true)
      .map(([id]) => id)
  );
}

/**
 * Pre-computed sets for frequently checked flags.
 * Used by dateFormat.ts and other modules for backward compatibility.
 */
export const EHR_PRE_LOCALIZED_SYSTEMS = getSystemsWithFlag('preLocalizedScheduledTime');
